module.exports = __webpack_public_path__ + "static/media/amazon-logo.478840ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amazon-logo.svg
// module id = 1693
// module chunks = 0